// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute } from "@tanstack/react-router";
import { Loading } from "@/layouts/loading";
import Component from "./-components/component";
import { pharmacyClient } from "@/connect";

export const Route = createFileRoute("/(pharma)/_layout/patients/patient-info/$patientId/")({
  component: Component,
  loader: async ({ params }) => {
    if (!params.patientId) {
      throw new Error("Patient ID is required");
    }
    const { patientId } = params;
    const patientInfo =  await pharmacyClient.getPatient({
      patientId
    })
    const patientSales = await pharmacyClient.listSales({
      patientId,
      page: 1,
      pageSize: 10,
    })

    return {
      patientInfo,
      patientSales,
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
});
